import React, {useEffect} from "react";
import {Col, Grid, Row} from "react-bootstrap";
import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM';
export default function Player({
    video_id,
    height = 360,
    width = 640,
    onListen,
    onLoad,
    onStart,
    onPause,
    onResume,
    onSeek,
    onCuepoint,
    onMediaView,
    onProgress,
    onFinish,
    onError
}) {

    let player;

    useEffect(() => {

        function loadPlayer() {

            var projectId = 'a48377e3ea6d8603fcafcb42130e3369';

            player = new window.SambaPlayer("player", { //player é o ID do elemento html que ele vai inserir o iframe
                height,
                width,
                ph: projectId,//Player Hash do projeto
                m: video_id,//MidiaID
                playerParams: { //Veja a lista de Parâmetros suportados
                    enableShare: false,
                    captionTheme: [20,'pt-BR'] //Define o tamanho da fonte e idioma padrão para que o vídeo já inicie com a legenda ativa.
                },
                events: { //Funcoes que escutam os eventos do player
                    onListen,
                    onLoad,
                    onStart: onStart || handleStartVideoGTM,
                    onPause: onPause || handlePauseVideoGTM,
                    onResume: onResume || handleResumeVideoGTM,
                    onSeek,
                    onCuepoint,
                    onMediaView: onMediaView || currentProgress,
                    onProgress,
                    onFinish: onFinish || onFinishVideoGTM,
                    onError,
                }
            });
        }

        loadPlayer();

    }, []);

    function handleStartVideoGTM(data) {
        const dataLayer = {
          event: 'video_change',
          titulo: data.title,
          status: 'start',
          progress: '0%'
        }
        addToDataLayerGTM(dataLayer);
      }

    const handlePauseVideoGTM = (data) => {
        const duration = data.duration;
        let currentTime;

        player.getStatus((data) => currentTime = data.status.time);

        const progress = Math.floor(((currentTime * 100) / duration) * 1000);

        const dataLayer = {
            event: 'video_change',
            titulo: data.title,
            status: 'pause',
            progress: `${progress}%`
        }
        addToDataLayerGTM(dataLayer);
    }

    const handleResumeVideoGTM = (data) => {
        const duration = data.duration;
        let currentTime;
    
        player.getStatus((data) => currentTime = data.status.time);
    
        const progress = Math.floor(((currentTime * 100) / duration) * 1000);
        const dataLayer = {
          event: 'video_change',
          titulo: data.title,
          status: 'play',
          progress: `${progress}%`
        }
        addToDataLayerGTM(dataLayer);
      }
    
    function onFinishVideoGTM(data) {
        const dataLayer = {
          event: 'video_change',
          titulo: data.title,
          status: 'complete',
          progress: '100%'
        }
        addToDataLayerGTM(dataLayer);
    }

    function currentProgress(data) {
        const dataLayer = {
          event: 'video_change',
          titulo: data.title,
          status: 'conteudo visualizado',
          progress: data.eventParam,
        }
        addToDataLayerGTM(dataLayer);
    }


    return (
        <div id="CoursePage">
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={1}></Col>
                        <Col md={10}>
                            <div>
                                <div className="embed-responsive embed-responsive-16by9 card shadow-sm">
                                    <div id="player"></div>
                                </div>
                            </div>
                        </Col>
                        <Col md={1}></Col>
                    </Row>
                </Grid>
            </div>
        </div>
    );
};





// WEBPACK FOOTER //
// ./src/components/Player/Player.jsx